import { render, staticRenderFns } from "./UserStatsChart.vue?vue&type=template&id=4b5bcda6&scoped=true&"
import script from "./UserStatsChart.vue?vue&type=script&lang=js&"
export * from "./UserStatsChart.vue?vue&type=script&lang=js&"
import style0 from "./UserStatsChart.vue?vue&type=style&index=0&id=4b5bcda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5bcda6",
  null
  
)

export default component.exports